import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { p, eur } from "@/lib/api";
import { usePlan } from "@/context/PlanContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Check, Lock, Sparkles } from "lucide-react";

export const UpgradeDialog = () => {
  const { plan, upgrade, closeUpgrade } = usePlan();
  const [loading, setLoading] = useState(null);
  const nav = useNavigate();

  if (!plan) return null;
  const plans = plan.plans.filter((x) => x.id !== "free");

  const buy = async (lookup_key) => {
    setLoading(lookup_key);
    try {
      const r = await p("/billing/checkout", { lookup_key, origin_url: window.location.origin });
      window.location.href = r.checkout_url;
    } catch (e) {
      toast.error("Impossibile aprire il pagamento");
      setLoading(null);
    }
  };

  return (
    <Dialog open={!!upgrade} onOpenChange={(v) => !v && closeUpgrade()}>
      <DialogContent className="max-h-[92vh] overflow-y-auto sm:max-w-2xl" data-testid="upgrade-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Lock className="h-4 w-4" /> Funzione non inclusa nel piano {plan.plan_name}
          </DialogTitle>
        </DialogHeader>
        {upgrade?.message && (
          <p className="rounded-md bg-amber-50 p-3 text-sm text-amber-900" data-testid="upgrade-message">
            {upgrade.message}
          </p>
        )}

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {plans.map((x) => (
            <div
              key={x.id}
              className={`rounded-lg border-2 p-5 ${
                upgrade?.needed === x.id ? "border-slate-900" : "border-slate-200"
              }`}
              data-testid={`upgrade-plan-${x.id}`}
            >
              <div className="flex items-baseline justify-between">
                <h3 className="font-head text-lg font-bold">{x.name}</h3>
                <p className="font-num text-2xl font-bold">
                  {eur(x.price)}
                  <span className="text-xs font-normal text-slate-500">/mese + IVA</span>
                </p>
              </div>
              <ul className="mt-3 space-y-1.5 text-sm">
                {x.highlights.map((h) => (
                  <li key={h} className="flex items-start gap-2 text-slate-600">
                    <Check className="mt-0.5 h-3.5 w-3.5 shrink-0 text-emerald-600" /> {h}
                  </li>
                ))}
              </ul>
              <Button
                className="mt-4 h-11 w-full"
                disabled={loading === x.lookup_key || plan.plan === x.id}
                data-testid={`upgrade-buy-${x.id}`}
                onClick={() => buy(x.lookup_key)}
              >
                {plan.plan === x.id ? "Piano attuale" : (
                  <>
                    <Sparkles className="mr-1.5 h-4 w-4" /> Passa a {x.name}
                  </>
                )}
              </Button>
            </div>
          ))}
        </div>

        <Button
          variant="ghost"
          className="w-full"
          data-testid="upgrade-see-plans-btn"
          onClick={() => {
            closeUpgrade();
            nav("/abbonamento");
          }}
        >
          Vedi tutti i dettagli dell'abbonamento
        </Button>
      </DialogContent>
    </Dialog>
  );
};
